import { TagCloudTargeting, TagValue } from '../../typings/tagCloudTargeting';

export const getDefaultTagCloudTargetingState = (): TagCloudTargeting => {
    return {
        includedValue: [],
        excludedValue: [],
        isOpen: false,
        canIncludeMinusValue: false
    };
};

export const getTagCloudTargetingId = (key: string, id: string): string => {
    return `${key}_${id}`;
};

export const isTargeting = (value: string): boolean => !/^\-/.test(value);

export const isFiltering = (value: string): boolean => !isTargeting(value);

export const addLeadingDash = (value: string): string =>
    isTargeting(value) ? `-${value}` : value;

export const mapTagValueToString = (value: TagValue): string => {
    return Array.isArray(value) ? value.join(' ') : value;
};

export const getUniqueArrayOfTargetingValues = (
    values: TagValue[]
): TagValue[] => {
    const flatValues: TagValue[] = [];

    return values.reduce((acc: TagValue[], value: TagValue): TagValue[] => {
        const flatValue = mapTagValueToString(value);

        if (flatValues.includes(flatValue)) {
            return acc;
        }

        flatValues.push(flatValue);
        return [...acc, value];
    }, []);
};
